var path = 'src/app/components/customer/credit-scoring/credit-scoring-modal-score-chart.template.html';
var html = "<canvas></canvas>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;